<div>
	@if (name) {
		<h4 class="gen-title section-title">{{ name | langVal }}</h4>
	}

	@for (section of sections; track section.tableName) {
		<div
			class="section-row"
			[style.background-color]="section.color"
			(click)="openSection(section)"
		>
			<button
				class="btn btn-icon"
				titleLang="expand"
				[icon]="section.isOpen ? 'report_expand' : 'report_expand'"
			></button>
			<!-- <h4 class="gen-title">{{ (section.isOpen ? "" : section.title) | langVal }}</h4> -->
			<h4 class="gen-title">
				{{ section?.title || section.tableName | langVal }}
			</h4>
		</div>
		@if (section.isOpen) {
			<div class="section-contents">
				@switch (section.tableName) {
					@case ("cc-insert-patient-templates") {
						<app-cc-insert-patient-templates />
					}
					@case ("patient-details-fields-manage") {
						<app-patient-details-fields-manage />
					}
					@case ("patient_unification") {
						<app-patient-unify />
					}
					@case ("import-patients") {
						<app-import-patients />
					}
					@case ("import-followups") {
						<app-import-followups />
					}
					@case ("cc-params-user-details") {
						<app-cc-params-user-details />
					}
					@case ("sub-user") {
						<app-cc-params-sub-user />
					}
					@case ("user") {
						<app-user />
					}
					@case ("import-tags") {
						<app-import-tags />
					}
					@case ("accountant") {
						<app-cc-params-accountant />
					}
					@case ("credit-clearance") {
						<app-cc-params-credit-clearance />
					}
					@case ("ita-get-auth") {
						<app-ita-get-auth />
					}
					@case ("tests") {
						<app-test-manage />
					}
					@case ("public_tests") {
						<app-cc-params-public-tests />
					}
					@case ("holiday") {
						<app-cc-params-holiday />
					}
					@case ("activity") {
						<app-activity />
					}
					@case ("invite_texts_approval") {
						<app-invite-texts-approval />
					}
					@case ("invite_texts") {
						<app-invite-texts />
					}
					@case ("admininvoices") {
						<app-user />
					}
					@case ("payment") {
						<app-payment-form />
					}
					@case ("change_password") {
						<app-change-password />
					}
					@case ("user-details-website") {
						<app-cc-params-user-details-website />
					}
					@default {
						@if (section?.isPagi) {
							<app-gen-table-pagination [tableName]="section.tableName" />
						} @else {
							<app-gen-table [tableName]="section.tableName" />
						}
					}
				}
			</div>
		}
		<!-- <hr class="separation-line" /> -->
	}
</div>
